var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-wrapper',{staticClass:"content"},[_c('app-wrapper',{attrs:{"content":true}},[_c('app-text',{attrs:{"text":_vm.text || _vm.$state.page.content}}),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }